export const cibAdobe = ["32 32","<path d='M20.136 2.667h11.864v26.667zM11.864 2.667h-11.864v26.667zM16 12.531l7.469 16.803h-5.068l-2.136-5.333h-5.463z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-adobe.js
// module id = null
// module chunks = 